import React, { useState } from 'react'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import IconButton from 'srcReact/components/common2/IconButton'
import IconButtonWithText from 'srcReact/components/common2/IconButtonWithText'
import Spinner from '../Spinner'
import { TextArea } from '../TextArea'
import LikeWithCount from './LikeWithCount'

const PromptCard = ({
  id,
  mode,
  editable,
  title,
  answer,
  likes,
  className,
  isLiked,
  handleNewPrompt,
  handleLikeOrDislike,
  handleComment,
  handleDelete,
  handleEdit,
  loading
}) => {
  const { t } = useTranslation()

  const [message, setMessage] = useState({
    name: 'message',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: false
  })

  if (mode === 'add') {
    return (
      <div role='button' className={`${styles.newPromptCard} ${className}`} onClick={handleNewPrompt}>
        <IconButtonWithText
          icon='add'
          text={title}
          wrapperCSS={styles.wrapperCSS}
          textCSS={styles.textCSS}
          iconWrapperCSS={styles.iconWrapperCSS}
        />
      </div>
    )
  }

  const sendMessage = () => {
    const msgValue = message.value
    setMessage({
      ...message,
      value: '',
      errorMessage: '',
      hasError: false
    })
    const msgWithPrompt = `<div class='promptInMessage'><div class='question'>${title}</div><div class='answer'> ${answer}</div></div> <div class='replyToPrompt'> ${msgValue}</div>`
    handleComment(msgWithPrompt)
  }

  return (
    <div className={`${styles.promptCard} ${className} ${loading ? styles.promptInProcess : ''} `}>
      {loading && (
        <div className={styles.disabledPromptCard}>
          <Spinner />
        </div>
      )}
      {editable && mode != 'reply' && (
        <div className={styles.header}>
          <IconButton
            aria-label={t('global.delete')}
            iconName='close24'
            iconSize='large24'
            iconCSS={styles.deleteIcon}
            className={styles.deleteIconButton}
            onClick={handleDelete}
          />
        </div>
      )}
      <div className={`${styles.content} ${!editable && styles.hasNotEditable}`}>
        <h2 className={styles.title}>{title}</h2>
        <p id={`answer_${id}`} className={styles.answer}>
          {answer}
        </p>
      </div>
      <div className={`${styles.footer} ${mode === 'reply' && styles.footerOnReply}`}>
        <LikeWithCount
          id={id}
          entity={{ users: likes?.users, prompt: { id: id, question: title, answer: answer } }}
          count={likes?.count || 0}
          onClick={handleLikeOrDislike}
          isLiked={isLiked}
          editable={editable}
        />

        {mode !== 'reply' ? (
          editable ? (
            <IconButton
              aria-label={t('global.edit')}
              iconName='edit'
              iconSize='large24'
              iconCSS={styles.editIcon}
              className={styles.editIconButton}
              onClick={handleEdit}
            />
          ) : (
            <IconButton
              aria-label={t('global.clickForComment')}
              iconName='write'
              iconSize='large24'
              iconCSS={styles.commentIcon}
              className={styles.commentIconButton}
              onClick={handleComment}
            />
          )
        ) : null}

        {mode === 'reply' && (
          <div className={styles.inputWrapper}>
            <TextArea
              rows={4}
              isRequired={false}
              fieldInfo={message}
              placeholder={t('my_profile.myPrompts.replyPrompt.placeholder')}
              onChange={(e) => {
                setMessage({ ...message, value: e.target.value })
              }}
              customWrapperCss={styles.textareaWrapper}
            />
            <IconButton iconName='send-copy' iconSize='large24' className={styles.btnSend} onClick={sendMessage} />
          </div>
        )}
      </div>
    </div>
  )
}

PromptCard.propTypes = {
  id: PropTypes.number.isRequired,
  mode: PropTypes.oneOf(['add', 'edit', 'view', 'reply']),
  title: PropTypes.string,
  editable: PropTypes.number,
  answer: PropTypes.string,
  isLiked: PropTypes.bool,
  likes: PropTypes.shape({
    count: PropTypes.number
  }),
  handleNewPrompt: PropTypes.func,
  handleLikeOrDislike: PropTypes.func,
  handleComment: PropTypes.func,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func
}

PromptCard.defaultProps = {
  mode: 'view',
  editable: 0,
  title: '',
  answer: '',
  isLiked: false,
  likes: {
    count: 0
  }
}

export default PromptCard
